import { getPathReduxUtil } from '../get-path'

function getChangedKeyPathReduxUtil (instance, foreignKey) {
  return `${getPathReduxUtil(instance)}.changed.${foreignKey}`
}

export { getChangedKeyPathReduxUtil }
